import React, { useEffect } from 'react'
import './style/index.css'
import image from '../../assets/RE4wE9Y.png'
import { useState } from 'react'
import itemIcon from '../../assets/item-center.png'
import Carousels from '../Carousel'
import classNames from 'classnames'

export default function Main() {
  // 内容点击展开
  const [showelem, setShowelem] = useState(false)
  const show = () => {
    if (showelem === false) {
      setShowelem(true)
    } else {
      setShowelem(false)
    }
    const expand = document.querySelector('.right-right')
    window.addEventListener('click', (event) => {
      if (!expand.contains(event.target)) {
        setShowelem(false)
      }
    })
  }
  // 浏览器滑动事件
  useEffect(() => {
    window.onscroll = function () {
      //变量t是滚动条滚动时，距离顶部的距离
      var t = document.documentElement.scrollTop || document.body.scrollTop
      var scrollup = document.getElementsByClassName('Main')
      var MainTop = document.getElementsByClassName('Main-top')
      const top = document.getElementsByClassName('top')
      const historys = document.getElementsByClassName('historys')
      const advertisement = document.getElementsByClassName('advertisement')
      const qh = document.getElementsByClassName('qh')
      if (t >= 276) {
        // 历史模块隐藏
        historys[0].style.opacity = 0
      } else {
        historys[0].style.opacity = 100
      }
      if (t >= 350) {
        //广告模块隐藏
        advertisement[0].style.opacity = 0
      } else {
        advertisement[0].style.opacity = 100
      }
      //当滚动到距离顶部200px时，返回顶部的按钮显示
      if (t >= 1) {
        scrollup[0].style.backgroundColor = 'white'
        scrollup[0].style.color = 'black'
        MainTop[0].style.backgroundColor = 'white'
        qh[0].style.color = 'black'
        qh[1].style.color = 'black'
        qh[2].style.color = 'black'
      } else {
        //恢复正常
        scrollup[0].style.backgroundColor = 'rgba(0, 0, 0, 0.4)'
        scrollup[0].style.color = 'aliceblue'
        MainTop[0].style.backgroundColor = 'rgba(0, 0, 0, 0)'
        qh[0].style.color = 'aliceblue'
        qh[1].style.color = 'aliceblue'
        qh[2].style.color = 'aliceblue'
      }
      if (t >= 436) {
        top[0].style.backgroundImage = `url(${image})`
      } else {
        //恢复正常
        top[0].style.backgroundImage = ''
      }
    }
  }, [])
  //导航标签
  const [navigation] = useState({
    navItem: [
      { name: '我的资讯' },
      { name: '导航' },
      { name: 'ChatGPT' },
      { name: '资讯' },
      { name: '体育' },
      { name: '财经' },
      { name: '天气' },
      { name: '购物' },
      { name: '健康' },
      { name: '交通' },
    ],
  })
  //导航标签右侧
  const [navrigth] = useState({
    navList: [
      { id: 1, name: '仅标题' },
      { id: 2, name: '内容部分可见' },
      { id: 3, name: '可见内容' },
    ],
  })
  const [navactive, setNavactive] = useState('内容部分可见')
  //导航选中
  const [active, setActive] = useState(0)
  useEffect(() => {
    const main = document.querySelector('.Main')
    const historys = document.querySelector('.historys')
    const expand = document.querySelector('.r-r-expand')
    if (navactive === '内容部分可见') {
      historys.style.marginTop = '200px'
      main.style.marginTop = ''
      expand.style.top = ''
    } else if (navactive === '仅标题') {
      historys.style.marginTop = '200px'
      main.style.marginTop = '560px'
      expand.style.top = '-95px'
    } else {
      historys.style.marginTop = '100px'
      main.style.marginTop = ''
      expand.style.top = ''
    }
  }, [navactive])
  //内容区域
  const [content] = useState({
    contentItem: [
      {
        name: '中关村',
        img: require('../../assets/item.png'),
        content: '被人摸后背后，迪丽热巴继续穿露背装出行，多位警察在场维持秩序',
        time: 13,
        like: 32,
        dislike: 53,
      },
      {
        name: 'westrrt',
        img: require('../../assets/item.png'),
        content: '三星 One UI 6 即将上线，带来大量功能更新及优化',
        time: 3,
        like: 24,
        dislike: 3,
      },
      {
        name: '京东',
        img: require('../../assets/item.png'),
        content: '《八角笼中》票房破14亿，李连杰调侃，王宝强为啥不请流量明星？',
        time: 13,
        like: 3,
        dislike: 5,
      },
      {
        name: '唯品会',
        img: require('../../assets/item.png'),
        content: '曝三星Galaxy S24 Ultra配5000mAh叠片式电池，支持65W快充',
        time: 13,
        like: 32,
        dislike: 53,
      },
      {
        name: 'BOSS自聘',
        img: require('../../assets/item.png'),
        content: '文咏珊调侃陈思诚:怎样才能要到王宝强微信?陈思诚回应让人笑翻',
        time: 13,
        like: 322,
        dislike: 53,
      },
      {
        name: '唯品会',
        img: require('../../assets/item.png'),
        content: '曝三星Galaxy S24 Ultra配5000mAh叠片式电池，支持65W快充',
        time: 13,
        like: 32,
        dislike: 53,
      },
      {
        name: 'BOSS自聘',
        img: require('../../assets/item.png'),
        content: '文咏珊调侃陈思诚:怎样才能要到王宝强微信?陈思诚回应让人笑翻',
        time: 13,
        like: 322,
        dislike: 53,
      },
      {
        name: '唯品会',
        img: require('../../assets/item.png'),
        content: '曝三星Galaxy S24 Ultra配5000mAh叠片式电池，支持65W快充',
        time: 13,
        like: 32,
        dislike: 53,
      },
    ],
  })
  return (
    <>
      {/*  主体区域 */}
      <div className="Main">
        {/* 导航栏 */}
        <div className="Main-top">
          {/* 导航栏左侧 */}
          <div className="top-left">
            <div className="left-item">
              <i className="qh iconfont icon-gengduo"></i>
            </div>
            {navigation.navItem.map((item, index) => (
              <div
                className={classNames('left-item', {
                  active: index === active,
                })}
                key={index}
                onClick={() => {
                  setActive(index)
                }}>
                <span>{item.name}</span>
              </div>
            ))}
          </div>
          {/* 导航栏右侧 */}
          <div className="top-right">
            <div className="right-left">
              <i className="qh iconfont icon-favorites"></i>
              <span>个性化设置</span>
            </div>
            <div className="right-right" onClick={show}>
              <span>{navactive}</span>
              <i className="qh iconfont icon-xiajiantou"></i>
              <div
                className="r-r-expand"
                style={{ display: showelem ? 'block' : 'none' }}>
                {navrigth.navList.map((item) => (
                  <div
                    className="expand-item"
                    key={item.id}
                    onClick={() => setNavactive(item.name)}>
                    <span>{item.name}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        {/* 内容区域 */}
        <div className="Main-center">
          <div className="center-list">
            <Carousels />
            {content.contentItem.map((item, index) => (
              <div className="center-item" key={index}>
                <div className="item-top">
                  <img src={item.img} alt="" />
                </div>
                <div className="item-bottom">
                  <div className="b-top">
                    <img src={itemIcon} alt="" />
                    <span>{item.name}</span>. <span>{item.time}小时前</span>
                  </div>
                  <div className="b-center">
                    <span>{item.content}</span>
                  </div>
                  <div className="b-bottom">
                    <div className="b-left">
                      <div className="dianzan">赞</div>
                      <i className="iconfont icon-dianzan"></i>
                      <span>{item.like}</span>
                    </div>
                    <div className="b-right">
                      <div className="dislike">不喜欢</div>
                      <i className="iconfont icon-buxihuan"></i>
                      <span>{item.dislike}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            <Carousels />
          </div>
        </div>
      </div>
    </>
  )
}
